import { effects } from 'redux-saga'

import {
  LOAD_PARTNER_ACCESS,
  LOAD_PARTNERS,
  RECEIVE_PARTNERS,
} from '../../modules/partner/reducer'

import load from './load'
import loadAccess from './loadAccess'
import receiveRelatedClients from './receiveRelatedClients'

export default function* partner(apis) {
  yield [
    effects.takeEvery(LOAD_PARTNER_ACCESS, loadAccess, apis),
    effects.takeEvery(LOAD_PARTNERS, load, apis),
    effects.takeEvery(RECEIVE_PARTNERS, receiveRelatedClients),
  ]
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/partner/index.js